export default {
    methods: {
        getErrorTab(lang) {
            if(this.block?.errors?.translations?.[lang]) {

                return true
            }

            return false;
        }
    }
}